import React, { useState } from 'react';
import { Select, MenuItem, Button, FormControl, InputLabel, Grid } from '@mui/material';

const SingleSelection = ({
    items,
    keyField,
    valueField,
    labelField,
    separator = ' - ',
    buttonLabel,
    onItemSelected,
    onButtonClick,
    loading =false,
    selectLabel = "Sec"
}) => {
    const [selectedItem, setSelectedItem] = useState('');

    const handleChange = (event) => {
        const value = event.target.value;
        setSelectedItem(value);

        const selectedObject = items.find(item => item[valueField] === value);
        if (onItemSelected) {
            onItemSelected(selectedObject); // Notify parent with the selected object
        }
    };

    const getLabel = (item) => {
        if (!item) {
            // If item is undefined or null, return an empty string or placeholder
            return '';
        }

        if (Array.isArray(labelField)) {
            return labelField.map(field => item[field]).join(separator);
        }
        return item[labelField] ?? "";
    };

    const handleButtonClick = async () => {
        if (selectedItem !== '' && onButtonClick) {
            const selectedObject = items.find(item => item[valueField] === selectedItem);
            await onButtonClick(selectedObject); // Trigger async function with selected object
        }
    };

    return (
        <FormControl margin="dense" size="small" variant="outlined" fullWidth>
            <Grid container spacing={2}>
                <Grid item xs={8}>
                    <InputLabel id="select-item-label">{selectLabel}</InputLabel>
                    <Select
                        label={selectLabel}
                        value={selectedItem}
                        InputLabelProps={{ shrink: true }}
                        onChange={handleChange}
                        renderValue={(selected) => getLabel(items.find(item => item[valueField] === selected)) || ''}
                        fullWidth
                    >
                        {items.map((item) => (
                            <MenuItem key={item[keyField]} value={item[valueField]}>
                                {getLabel(item)}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
                <Grid item xs={4}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleButtonClick}
                        disabled={selectedItem === '' || loading}
                        style={{ marginTop: '1px' }}
                    >
                        {buttonLabel}
                    </Button>
                </Grid>
            </Grid>
        </FormControl>
    );
};

export default SingleSelection;
